import core from './src/core'
import dict from './src/dict'
import {defineStoreCreator} from "../utils/creator/StoreCreator";

export default defineStoreCreator([
    core, dict
]);
